import React, { useEffect, useMemo, useState } from "react";
import CustomSelect from "../input/select";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import Chip from "@mui/material/Chip";
import classNames from "classnames";

const Input = ({
  name,
  error,
  validation,
  rowHasError,
  errorMessage,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={2}
          name={name}
          value={value || ""}
          disabled={props.readonly}
          onChange={handleOnChange}
          style={{ width: "100%" }}
        />
      </div>
    </>
  );
};

const DropdownWithOther = ({
  options,
  onSelectChange,
  onInputChange,
  item,
  setRowData,
  rowData,
  editData,
  sourceData,
  rowHasError,
  errorMessage,
  setRowHasError,
  tableName,
  allRowsData,
  updateSourceInputs,
  handleOnSelectChange,
  isMultiSelect = false,
  readonly = false,
  setRbBrandValues = () => {},
}) => {
  const [isOther, setIsOther] = useState(
    rowData[item.name] && rowData[item.name] === "+ Other",
  );
  const [isOtherNewMappingType, setIsOtherNewMappingType] = useState(false);
  const [otherValue, setOtherValue] = useState();
  const OPTIONS = [...(Array.isArray(options) ? options : []), "+ Other"];

  // FOR MARKET MAPPING, GOLD TM USECASE
  const isNewMappingTypeAdded = useMemo(() => {
    const result = sourceData?.isNewMappingType_logs?.some((item) =>
      sourceData?.data.dropdown.duplicate_validation_attributes?.every?.(
        (key) => item?.[key] === editData?.[key],
      ),
    );
    return (
      (item.name === "MAPPING_TYPE" ||
        item.name === "GLOBAL_RETAILER" ||
        item.name === "GOLD_TARGET_COLUMN_NAME") &&
      result
    );
  }, [editData, rowData]);

  // FOR PRODUCT MAPPING USECASE
  const isNewLocalValueAdded = useMemo(() => {
    const result = sourceData?.isNewLocalValue_logs?.some((item) =>
      sourceData?.data.dropdown.duplicate_validation_attributes?.every?.(
        (key) => item?.[key] === editData?.[key],
      ),
    );
    return item.name === "LOCAL_VALUE" && result;
  }, [editData, rowData]);

  // FOR PRODUCT MAPPING USECASE
  const isNewMappedValueAdded = useMemo(() => {
    const result = sourceData?.isNewMappedValue_logs?.some((item) =>
      sourceData?.data.dropdown.duplicate_validation_attributes?.every?.(
        (key) => item?.[key] === editData?.[key],
      ),
    );
    return item.name === "GLOBAL_VALUE" && result;
  }, [editData, rowData]);

  // FOR P&PB USECASE
  const isNewPowerBrandAdded = useMemo(() => {
    const result = sourceData?.isNewPowerBrand_logs?.some((item) =>
      sourceData?.data.dropdown.duplicate_validation_attributes_for_other_flow?.every?.(
        (key) => item?.[key] === editData?.[key],
      ),
    );

    return (
      sourceData?.data?.dropdown?.columns_with_other_options?.includes(
        item.name,
      ) && result
    );
  }, [editData, rowData]);

  const isNewRBFiltredBrandAdded = useMemo(() => {
    const result = sourceData?.isNewRBFilteredBrand_logs?.some((item) =>
      sourceData?.data.dropdown.duplicate_validation_attributes_for_other_flow?.every?.(
        (key) => item?.[key] === editData?.[key],
      ),
    );
    return (
      sourceData?.data?.dropdown?.duplicate_validation_attributes_for_other_flow?.includes(
        item.name,
      ) && result
    );
  }, [editData, rowData]);

  const IsExistingRecordsNewForRevert = useMemo(() => {
    if (
      (editData?.ISNEW_MAPPING_TYPE && !isNewMappingTypeAdded) ||
      (editData?.ISNEW_LOCAL_VALUE && !isNewLocalValueAdded) ||
      (editData?.ISNEW_GLOBAL_VALUE && !isNewMappedValueAdded) ||
      ((editData?.ISNEW_RB_FILTERED_BRAND || editData?.ISNEW_POWER_BRAND) &&
        (!isNewRBFiltredBrandAdded || !isNewPowerBrandAdded))
    ) {
      return true;
    }
    return false;
  }, [editData, rowData]);

  const validation = () => {
    return true;
  };

  const handleSelect = (key, val, columnName) => {
    const selected = val;
    if (selected === "+ Other") {
      if (
        !isNewMappingTypeAdded &&
        (item.name === "MAPPING_TYPE" ||
          item.name === "GLOBAL_RETAILER" ||
          item.name === "GOLD_TARGET_COLUMN_NAME")
      ) {
        updateSourceInputs("isNewDropdownValue", true);
      }
      if (!isNewLocalValueAdded && item.name === "LOCAL_VALUE") {
        updateSourceInputs("isNewDropdownLocalValue", true);
      }
      if (!isNewMappedValueAdded && item.name === "GLOBAL_VALUE") {
        updateSourceInputs("isNewDropdownMappedValue", true);
      }

      if (
        (!isNewRBFiltredBrandAdded || !isNewPowerBrandAdded) &&
        sourceData?.data?.dropdown?.columns_with_other_options?.includes(
          item.name,
        )
      ) {
        if (!isNewRBFiltredBrandAdded) {
          updateSourceInputs("isNewRBFilteredBrandDropdownValue", true);
        }

        if (!isNewPowerBrandAdded) {
          updateSourceInputs("isNewPowerBrandDropdownValue", true);
        }
      }
      setIsOtherNewMappingType(false);
      setIsOther(true);
    } else {
      setIsOther(false);
      onSelectChange(key, val, columnName);
    }
  };

  const handleMultiSelect = (key, val, columnName) => {
    const selected = val;
    if (selected?.includes("+ Other")) {
      if (
        !isNewMappingTypeAdded &&
        (item.name === "MAPPING_TYPE" ||
          item.name === "GLOBAL_RETAILER" ||
          item.name === "GOLD_TARGET_COLUMN_NAME")
      ) {
        updateSourceInputs("isNewDropdownValue", true);
      }
      if (!isNewLocalValueAdded && item.name === "LOCAL_VALUE") {
        updateSourceInputs("isNewDropdownLocalValue", true);
      }
      if (!isNewMappedValueAdded && item.name === "GLOBAL_VALUE") {
        updateSourceInputs("isNewDropdownMappedValue", true);
      }

      if (
        (!isNewRBFiltredBrandAdded || !isNewPowerBrandAdded) &&
        sourceData?.data?.dropdown?.columns_with_other_options?.includes(
          item.name,
        )
      ) {
        if (!isNewRBFiltredBrandAdded && item.name === "FILTERED_RB_BRAND") {
          updateSourceInputs("isNewRBFilteredBrandDropdownValue", true);
        }

        if (!isNewPowerBrandAdded && item.name === "POWER_BRAND") {
          updateSourceInputs("isNewPowerBrandDropdownValue", true);
        }
      }
      setIsOtherNewMappingType(false);
      setIsOther(true);
    } else {
      setIsOther(false);
      handleOnSelectChange(key, val, columnName);
    }
  };

  const handleOtherInput = (e) => {
    const val = e.target.value;
    setOtherValue(val);
    if (isMultiSelect) {
      const ExistingValue =
        val && val?.length > 0
          ? rowData?.[item.name] && rowData?.[item.name]?.length > 0
            ? [rowData?.[item.name], e.target.value]
            : [e.target.value]
          : rowData?.[item.name];
      const FinalValue = ExistingValue?.join(",");
      setRbBrandValues(FinalValue);
    } else {
      onInputChange(e, item.name);
    }
  };

  const revert = () => {
    if (
      sourceData?.isNewDropdownValue &&
      (item.name === "MAPPING_TYPE" || item.name === "GLOBAL_RETAILER")
    ) {
      updateSourceInputs("isNewDropdownValue", false);
      setIsOtherNewMappingType(false);
    }
    if (sourceData?.isNewDropdownLocalValue && item.name === "LOCAL_VALUE") {
      updateSourceInputs("isNewDropdownLocalValue", false);
      setIsOtherNewMappingType(false);
    }
    if (sourceData?.isNewDropdownMappedValue && item.name === "GLOBAL_VALUE") {
      updateSourceInputs("isNewDropdownMappedValue", false);
      setIsOtherNewMappingType(false);
    }
    if (
      (sourceData?.isNewRBFilteredBrandDropdownValue ||
        sourceData?.isNewPowerBrandDropdownValue) &&
      sourceData?.data?.dropdown?.columns_with_other_options?.includes(
        item.name,
      )
    ) {
      if (isNewRBFiltredBrandAdded) {
        updateSourceInputs("isNewRBFilteredBrandDropdownValue", false);
      }

      if (isNewPowerBrandAdded) {
        updateSourceInputs("isNewPowerBrandDropdownValue", false);
      }
      if (isMultiSelect) {
        setRbBrandValues("");
      }
      setIsOtherNewMappingType(false);
    }
    if (
      isNewMappingTypeAdded ||
      isNewLocalValueAdded ||
      isNewMappedValueAdded ||
      isNewPowerBrandAdded ||
      isNewRBFiltredBrandAdded ||
      IsExistingRecordsNewForRevert
    ) {
      setIsOtherNewMappingType(!isOtherNewMappingType);
    }
    setIsOther(false);
    setRowData({ ...rowData, [item.name]: editData?.[item.name] || "" });
    setOtherValue("");
  };

  useEffect(() => {
    if (isOtherNewMappingType) return;

    const columnFlagMap = {
      MAPPING_TYPE: editData?.ISNEW_MAPPING_TYPE && !isNewMappingTypeAdded,
      LOCAL_VALUE: editData?.ISNEW_LOCAL_VALUE && !isNewLocalValueAdded,
      GLOBAL_VALUE: editData?.ISNEW_GLOBAL_VALUE && !isNewMappedValueAdded,
      POWER_BRAND: editData?.ISNEW_POWER_BRAND && !isNewPowerBrandAdded,
      RB_FILTERED_BRAND:
        editData?.ISNEW_RB_FILTERED_BRAND && isNewRBFiltredBrandAdded,
      GLOBAL_RETAILER: editData?.ISNEW_MAPPING_TYPE && !isNewMappingTypeAdded,
      GOLD_TARGET_COLUMN_NAME:
        editData?.ISNEW_MAPPING_TYPE && !isNewMappingTypeAdded,
    };

    if (columnFlagMap[item.name]) {
      setIsOther(true);
      setOtherValue(rowData[item.name]);
    }
  }, [
    editData,
    isNewMappingTypeAdded,
    isNewLocalValueAdded,
    isNewMappedValueAdded,
    isNewPowerBrandAdded,
    isNewRBFiltredBrandAdded,
    item.name,
    rowData,
    isOtherNewMappingType,
  ]);

  useEffect(() => {
    if (isOtherNewMappingType) return;

    const columnFlagMap = {
      MAPPING_TYPE: isNewMappingTypeAdded,
      LOCAL_VALUE: isNewLocalValueAdded,
      GLOBAL_VALUE: isNewMappedValueAdded,
      POWER_BRAND: isNewPowerBrandAdded,
      RB_FILTERED_BRAND: isNewRBFiltredBrandAdded,
      GLOBAL_RETAILER: isNewMappingTypeAdded,
      GOLD_TARGET_COLUMN_NAME: isNewMappingTypeAdded,
    };

    if (columnFlagMap[item.name]) {
      setIsOther(true);
      setOtherValue(rowData?.[item.name] || "");
    }
  }, [
    editData,
    isNewMappingTypeAdded,
    isNewLocalValueAdded,
    isNewMappedValueAdded,
    isNewPowerBrandAdded,
    isNewRBFiltredBrandAdded,
    item.name,
    rowData,
    isOtherNewMappingType,
  ]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      {!isOther &&
        (isMultiSelect ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              width: "100%",
            }}
          >
            <Autocomplete
              multiple
              disabled={readonly}
              disableCloseOnSelect
              options={OPTIONS || []}
              value={
                rowData[item.name] === null || rowData[item.name] === "null"
                  ? []
                  : rowData[item.name].split(/\s*,\s*/).map((v) => v.trim())
              }
              onChange={(e, newValue) => {
                handleMultiSelect(item.name, newValue, item.name);
              }}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  style={{ marginLeft: option !== "+ Other" ? "0px" : "8px" }}
                >
                  {option !== "+ Other" && (
                    <Checkbox
                      checked={selected}
                      sx={{ padding: "2px", transform: "scale(0.9)" }}
                    />
                  )}
                  {option}
                </li>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={option}
                    size="small"
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => <TextField {...params} />}
              sx={{
                fontSize: "12px",

                "& .MuiAutocomplete-inputRoot": {
                  minHeight: "fit-content",
                  minWidth: "280px",
                  width: "100%",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                },

                "& .MuiAutocomplete-tag": {
                  margin: "2px",
                },
              }}
              slotProps={{
                popper: {
                  sx: {
                    "& .MuiAutocomplete-listbox": {
                      fontSize: "12px",
                    },
                  },
                },
              }}
            />
          </div>
        ) : (
          <CustomSelect
            errorMessage={errorMessage}
            classes={{}}
            tableName={tableName}
            name={item.name}
            onChange={(key, val) => {
              handleSelect(key, val, item.name);
            }}
            options={OPTIONS || []}
            customStyles={{}}
            value={
              rowData[item.name] === null || rowData[item.name] === "null"
                ? ""
                : rowData[item.name]
            }
            error={item.error}
            selectMessage={item.selectMessage}
            validation={item.validation}
            readonly={
              readonly ||
              (OPTIONS || []).length === 0 ||
              (item.isValidation && rowData[item.validation] === null) ||
              rowData[item.validation] === ""
                ? true
                : false
            }
            showLabel={false}
            derivedOptions={[]}
            sourceData={sourceData}
          />
        ))}

      {isOther && (
        <div style={{ width: "100%" }}>
          <Input
            errorMessage={errorMessage}
            rowHasError={rowHasError}
            columnDataArr={(allRowsData || []).map(
              (obj) => obj.rowData[item.name],
            )}
            tableName={tableName}
            classes={{}}
            type={item.type}
            name={item.name}
            onChange={handleOtherInput}
            readonly={
              (item.isValidation && rowData[item.validation] === null) ||
              rowData[item.validation] === ""
                ? true
                : false
            }
            value={otherValue || ""}
            item={item.name}
            childHasError={(bool) => setRowHasError(bool)}
            error={item.error}
            validation={validation}
          />
        </div>
      )}

      {(isNewMappingTypeAdded ||
        isNewLocalValueAdded ||
        isNewMappedValueAdded ||
        IsExistingRecordsNewForRevert ||
        isOther) && (
        <div onClick={revert} style={{ cursor: "pointer" }}>
          <span
            className="material-symbols-outlined"
            style={{
              color: "gray",
              fontVariationSettings: "'wght' 700, 'GRAD' 200",
            }}
          >
            change_circle
          </span>
        </div>
      )}
    </div>
  );
};

export default DropdownWithOther;
